<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import SportEventStore from '@/Stores/Sport/SportEventStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	// Constants
	import { Status, StatusName } from '@/Constants/Market';

	export let event;
	export let open;

	let sending = false;

	const dispatch = createEventDispatcher();

	function updateAllMarkets(newStatusId) {
		sending = true;
		SportEventStore.updateAllMarkets(event.id, {
			override_status_id: newStatusId
		})
			.then(() => {
				notify({
					type: 'success',
					title: event.name,
					message: newStatusId
						? `All Markets Status Overrides updated to ${StatusName[newStatusId]}`
						: 'All Market Status Overrides have been removed',
					timeout: 3
				});
				dispatch('updated');
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update all markets override status',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)} className="md:w-2/3 lg:w-1/2 mx-2 md:mx-auto">
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">All market controls for '{event.name}'</h2>
		<div class="flex w-full justify-center">
			<p>Status controls only work on markets that have not been resulted.</p>
		</div>
		<div class="flex flex-col w-full px-4 pt-6 text-left px-30 space-y-8">
			<div class="flex flex-col w-full text-left grid grid-cols-2 space-y-4">
				<div class="flex justify-center">
					<LoadingButton
						loading={sending}
						disabled={sending}
						on:click={() => updateAllMarkets(Status.Closed)}
						class="flex items-center justify-center p-3 bg-red-500 btn btn-primary-action"
					>
						<span class="flex-1">Override all markets closed</span>
					</LoadingButton>
				</div>
				<div class="flex justify-start items-center">Override the status of all markets to "CLOSED"</div>
				<div class="flex justify-center">
					<LoadingButton
						loading={sending}
						disabled={sending}
						on:click={() => updateAllMarkets(Status.Open)}
						class="flex items-center justify-center p-3 bg-green-500 btn btn-primary-action"
					>
						<span class="flex-1">Override all markets open</span>
					</LoadingButton>
				</div>
				<div class="flex justify-start items-center">Override the status of all markets to "OPEN"</div>
				<div class="flex justify-center">
					<LoadingButton
						loading={sending}
						disabled={sending}
						on:click={() => updateAllMarkets(Status.Suspended)}
						class="flex items-center justify-center p-3 bg-orange-500 btn btn-primary-action"
					>
						<span class="flex-1">Override all markets suspended</span>
					</LoadingButton>
				</div>
				<div class="flex justify-start items-center">Override the status of all markets to "SUSPENDED"</div>
				<div class="flex justify-center">
					<LoadingButton
						loading={sending}
						on:click={() => updateAllMarkets(null)}
						disabled={sending}
						class="flex items-center justify-center p-3 bg-blue-500 btn btn-primary-action"
					>
						<span class="flex-1">Remove all Status overrides</span>
					</LoadingButton>
				</div>
				<div class="flex justify-start items-center">Remove all current status overrides on all markets</div>
			</div>
			<LoadingButton
				class="flex items-center justify-center btn btn-muted"
				loading={sending}
				disabled={sending}
				on:click={() => (open = false)}
				>Cancel
			</LoadingButton>
		</div>
	</Modal>
{/if}
